import { render, staticRenderFns } from "./TongxinDateSelector.vue?vue&type=template&id=5f536836&scoped=true&"
import script from "./TongxinDateSelector.vue?vue&type=script&lang=js&"
export * from "./TongxinDateSelector.vue?vue&type=script&lang=js&"
import style0 from "./TongxinDateSelector.vue?vue&type=style&index=0&id=5f536836&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f536836",
  null
  
)

export default component.exports